import React from 'react';
import icons from '../assets/svg/icons.svg';

interface Props {
  name: string;
  size?: string;
  color?: string;
}

const Icon: React.FC<Props> = ({ name, size = '24px', color = 'currentColor' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={`icon icon-${name}`}
      width={size}
      height={size}
      fill={color}
>
      <use xlinkHref={`${icons}#${name}`} />
    </svg>
  );
}

export default Icon;
